export default __webpack_public_path__ + "static/custom-bahrain-7d61af11226be9cf89fb1f02dae4cdd3.webp";